export default __webpack_public_path__ + "static/media/export-icon.8913df01.svg";